import { FragmentOf, readFragment } from "gql.tada";

import ImageFragment from "./imageFragment";
import { NonNull } from "../../types";
import { hasId } from "../../utils/store";

export const readImageFragment = (
  fragment: FragmentOf<typeof ImageFragment> | null | undefined,
) => {
  if (!fragment) return null;

  const image = readFragment(ImageFragment, fragment);

  return hasId(image) ? (image as NonNull<typeof image>) : null;
};
